import { ReactElement, CSSProperties } from 'react';
import { Theme, makeStyles } from '@material-ui/core';
import { Tooltip } from 'portal-commons';

// To override Tooltip's default styles portal-commons
const useStyles = makeStyles<Theme, CSSProperties>({
  arrow: {
    '&&': {
      color: '#0091B3',
    },
  },
  tooltip: {
    '&&': {
      color: '#fff',
      fontSize: 12,
      borderRadius: '3px !important',
      maxWidth: '400px !important',
      fontFamily: 'Roboto',
      fontWeight: 400,
      padding: (props) => props.padding || '5px 15px !important',
      backgroundColor: '#0091B3',
    },
  },
  tooltipPlacementTop: {
    '&&': {
      top: 10,
    },
  },
  tooltipPlacementLeft: {
    '&&': {
      borderBottomRightRadius: '3px !important',
    },
  },
  tooltipPlacementRight: {
    '&&': {
      borderBottomLeftRadius: '3px !important',
    },
  },
});

interface Props {
  tooltipStyle?: CSSProperties;
  children?: ReactElement;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

const CustomTooltip: React.FC<Props> = ({
  tooltipStyle = {},
  children,
  ...props
}) => {
  const classes = useStyles(tooltipStyle);
  return (
    <Tooltip
      title={props.title}
      classes={classes}
      style={{ color: '#68737A' }}
      {...props}
    >
      {children}
    </Tooltip>
  );
};

export default CustomTooltip;
